import React, { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { Navbar } from './components/Navbar';
import { HomePage } from './components/HomePage';
import { IconSearch } from './components/IconSearch';
import { FavoritesPage } from './components/FavoritesPage';
import { SettingsPage } from './components/SettingsPage';
import { AIIconEditor } from './components/AIIconEditor';
import Pricing from './components/pricing';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import { useAppStore } from './stores/appStore';
import { useAuthStore } from './stores/authStore';
import { onAuthStateChanged } from './services/auth';
import { upsertUser } from './services/users';
import { toast } from 'sonner';

function App() {
  const { downloadProgress } = useAppStore();
  const { setUser } = useAuthStore();

  useEffect(() => {
    const unsub = onAuthStateChanged((u) => {
      setUser(u ? { displayName: u.displayName, email: u.email, photoURL: u.photoURL } : null);
      if (u) {
        Promise.resolve(upsertUser(u.uid)).catch((err) => {
          console.error('Supabase upsert user error:', err);
          toast.error('Failed to save user profile');
        });
      }
    });
    return () => { (unsub as any)?.(); };
  }, [setUser]);

  return (
    <HelmetProvider>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Navbar downloadProgress={downloadProgress} />

          <main className="pb-20 md:pb-0">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/search" element={<IconSearch />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/ai-editor" element={<AIIconEditor icon={null} onClose={() => {}} standalone={true} />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsOfService />} />
            </Routes>
          </main>

          <Toaster
            position="top-right"
            duration={3000}
            style={{
              background: '#ffffff',
              color: '#374151',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
            }}
          />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
